<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>

                        </div>
                        <div>
                            <el-form-item label="会计科目">
                                <el-input style="width: 180px" v-model="accTitleName" placeholder="选择会计科目" readonly
                                          @click.native="clickAccTitle">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="凭证日期">
                                <el-date-picker
                                        v-model="yearMonth"
                                        size="medium"
                                        type="monthrange"
                                        value-format="yyyy-MM"
                                        format="yyyy-MM"
                                        unlink-panels
                                        range-separator="至"
                                        start-placeholder="开始月份"
                                        end-placeholder="结束月份">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
        <selAccTitle v-if="showAccTitle"
                     :accTitleData="accTitleData"
                     @closeDialog="closeDialog"
                     @checkRow="checkAccTitle">
        </selAccTitle>
    </div>
</template>

<script>
    import selAccTitle from '@/components/page/finance/accountingtitle/selAccTitle'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selAccTitle
        },
        data() {
            return {
                searBarHeight: 70,

                showAccTitle:false,
                yearMonth:[],
                accTitleName:"",
            }
        },
        methods: {
            closeDialog() {
                this.showAccTitle = false;
            },
            checkAccTitle(row){
                this.accTitleName = row.name
                this.showAccTitle = false;
            },
            clickAccTitle(){
                this.accTitleName = this.name;
                this.showAccTitle = true;
            },
            search() {

                let startMonth = "";
                let endMonth = "";
                if(this.yearMonth && this.yearMonth.length>0){
                    startMonth = this.yearMonth[0];
                    endMonth = this.yearMonth[1];
                }
                let searchData = {
                    startMonth:startMonth,
                    endMonth:endMonth,
                    accTitleName:this.accTitleName
                }
                this.$emit('search',searchData);
            },
            excel() {
                let startMonth = "";
                let endMonth = "";
                if(this.yearMonth && this.yearMonth.length>0){
                    startMonth = this.yearMonth[0];
                    endMonth = this.yearMonth[1];
                }
                let searchData = {
                    startMonth:startMonth,
                    endMonth:endMonth,
                    accTitleName:this.accTitleName
                }
                this.$emit('excel',searchData);
            }
        }
    }
</script>

